module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.af7ae50.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/fa/fontawesome-webfont.woff2
// module id = 696
// module chunks = 1